type Classes = Partial<typeof baseClasses>
const baseClasses = {
  container: '',
  size: 'w-9 h-9',
  fill: 'fill-black',
}

export default function CurvedCorner({ classes }: { classes: Classes }) {
  classes = {
    ...baseClasses,
    ...classes,
  }
  return (
    <svg
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className={`${classes.container ?? ''} ${classes.size ?? ''}`}
      preserveAspectRatio="none"
    >
      <path
        d="M100 100H0C55.2285 100 100 55.2285 100 0V100Z"
        className={classes.fill}
      />
    </svg>
  )
}
